import {mapMutations} from 'vuex';

export default {
    methods: {
        ...mapMutations({
            SET_AUTH_DIALOG: "auth/SET_AUTH_DIALOG"
        }),
      showAuthDialog() {
          this.SET_AUTH_DIALOG(true)
      }
    },
}
